import { Filters } from '@/types';

export const createFilterParams = (filters: Filters) => {
  const params = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]) => {
    if (value === null || value === undefined) return;

    if (Array.isArray(value)) {
      value.forEach((item) => {
        params.append(`${key}[]`, String(item));
      });
    } else if (typeof value === 'boolean') {
      params.append(key, value.toString());
    } else if (typeof value === 'string') {
      params.append(key, value);
    } else {
      params.append(key, String(value));
    }
  });

  return params.toString();
};

export const createFilterBody = (filters: Filters) => {
  const bodyFilters: Record<string, any> = {};
  Object.entries(filters).forEach(([key, value]) => {
    if (value === null || value === undefined) return;

    if (Array.isArray(value)) {
      // Skip empty arrays - don't send them to the backend
      if (value.length === 0) return;

      bodyFilters[key] = [];
      value.forEach((item) => {
        bodyFilters[key].push(item?.value ?? item);
      });
    } else if (value instanceof Date) {
      bodyFilters[key] = value.toISOString();
    } else {
      bodyFilters[key] = value;
    }
  });
  const body = {
    ...bodyFilters,
  };

  return body;
};
